import React from "react";
import {connect} from 'dva';

const Pc = React.lazy(() => import('./pc'));
const Mobile = React.lazy(() => import('./mobile'));

/**
 * miniProgram  微信小程序内判断
 */
function Platform() {
    var isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否是移动端
    var isMiniProgram  = window.navigator.userAgent.match(/miniProgram/i);
    if (isMobile || isMiniProgram) {
        return <Mobile/>;
    } else {
        return <Pc/>;
    }
}

export default connect()(Platform);
